<template>
  <div
    class="column"
    :style="`flex-basis: ${width}`"
  >
    <slot />
  </div>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  export default defineNuxtComponent({
    name: 'CoreColumn',
    props: {
      width: {
        type: String as PropType<string>,
        default: null,
      },
    },
  });
</script>

<style lang="scss" scoped>
  @use '~/scss/article' as *;

  .column {
    :deep() > {
      @include article-elems;
    }
  }
</style>
